export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: 'plot',
    name: '剧情介绍',
    description: '深入了解赤裸特工的完整剧情脉络，从第一季到最新季，掌握每个关键转折与悬疑伏笔。',
    icon: 'ri-movie-2-line',
    articleCount: 24,
  },
  {
    slug: 'cast',
    name: '演员阵容',
    description: '一览赤裸特工全明星卡司，了解每位演员的角色定位、表演风格与幕后花絮。',
    icon: 'ri-user-star-line',
    articleCount: 18,
  },
  {
    slug: 'behind-scenes',
    name: '幕后故事',
    description: '揭秘赤裸特工的拍摄幕后，从动作设计到场景搭建，从导演访谈到特技揭秘。',
    icon: 'ri-camera-line',
    articleCount: 15,
  },
  {
    slug: 'watch-guide',
    name: '观看指南',
    description: '汇总赤裸特工各平台的在线观看渠道、播出时间表与完整版获取方式。',
    icon: 'ri-play-circle-line',
    articleCount: 12,
  },
  {
    slug: 'reviews',
    name: '剧评分析',
    description: '深度解析赤裸特工的叙事手法、人物塑造与主题表达，汇集专业影评与观众热议。',
    icon: 'ri-chat-quote-line',
    articleCount: 20,
  },
  {
    slug: 'news',
    name: '最新资讯',
    description: '追踪赤裸特工的最新动态，包括新季预告、剧组消息、宣传活动与相关新闻。',
    icon: 'ri-newspaper-line',
    articleCount: 30,
  },
];